import React, {createContext, useMemo, useReducer} from 'react';
import Layout from '../Shared/Layout';
import {Container} from "@material-ui/core";
import styled from "styled-components";
import FormPage from "../Shared/FormPage";
import { orderEntryConfig } from "../config/orderEntry";
import BackButton from "../Shared/BackButton";
import {DynamicColorPreset} from "../Shared/DynamicColorPreset";
import { Trans } from "../utils/i18n";
import MuiButton from "@material-ui/core/Button";
import {Inertia} from "@inertiajs/inertia";
import {usePage} from "@inertiajs/inertia-react";
import {returnServiceConfig} from "../config/returnService";
import {FormState} from "../FormComponents/FormState";
import { useSyncOrderState } from '../hooks/useSyncOrderState';

const SuccessPage = function ({ response }) {
    const { client } = usePage().props;
    const day = response?.pickup?.date;
    const timeslot_start = response?.pickup?.timeslot_start;
    const timeslot_end = response?.pickup?.timeslot_end;
    const logisticPartner = response?.pickup?.logisticPartner;
    const confirmationNumber = response?.pickup?.confirmationNumber;
    const trackingNumber = response?.label?.status?.return_tracking_ref;

    return (
        <div>
            <h2>
                <Trans i18nKey="formPage.returnServiceSuccess">Return label created</Trans>
            </h2>
            {
                response.pickup &&
                <p><Trans i18nKey="formPage.pickupConfirmationNote" day={day} logisticPartner={logisticPartner} confirmationNumber={confirmationNumber} timeslot_start={timeslot_start} timeslot_end={timeslot_end}>A pickup for your device was arranged for <b>{{day}} between {{timeslot_start}} and {{timeslot_end}}</b>. The {{logisticPartner}} Pickup Confirmation Number is {{confirmationNumber}}.</Trans></p>
            }
            <p><Trans getRaw i18nKey="formPage.downloadAndPrint" logisticPartner={logisticPartner} trackingNumber={trackingNumber}>Please download and print out your return label. Your {{logisticPartner}} tracking number is {{trackingNumber}}.</Trans></p>
            <MuiButton
                variant="contained"
                color={'secondary'}
                href={route('returnservice.downloadReturnLabel', { file: response?.label?.file?.id })}
            >
                <Trans i18nKey="formPage.download">Download</Trans>
            </MuiButton>
        </div>
    );
}

export default function ReturnService({ parcel_services, user, client, orderPrefilled }) {
    const { defaultFormValues, defaultOrderEntryState, isMetadataLoading, hasOrderNumber } = useSyncOrderState({
        queryKey: ["returnservice"]
    });

    // Since we want to initialize the form and the order state based on the metadata
    // of the order, we need to wait until the metadata is loaded.
    if (hasOrderNumber && isMetadataLoading) {
        return null;
    }

    return (
        <FormState defaultState={{ parcel_services, emailConfirmed: false, orderPrefilled, ...defaultOrderEntryState,}}>
            <div>
                <Container maxWidth="md">
                    { user && <BackButton/> }
                    <h1><Trans i18nKey="returnService">Return Service</Trans></h1>
                    <FormPage
                        defaultValues={{ ordernumber: orderPrefilled || '', ...defaultFormValues, }}
                        orderEntryConfig={returnServiceConfig}
                        endpointUrl={route('returnservice.submit')}
                        SuccessPage={SuccessPage}/>
                </Container>
            </div>
        </FormState>
    )
}


ReturnService.layout = page => <Layout children={page} />;
